import { render, staticRenderFns } from "./KBLI.vue?vue&type=template&id=17025028&"
import script from "./KBLI.vue?vue&type=script&lang=js&"
export * from "./KBLI.vue?vue&type=script&lang=js&"
import style0 from "./KBLI.vue?vue&type=style&index=0&id=17025028&prod&lang=css&"
import style1 from "./KBLI.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports